export const gitInfo = ' (main #6f3c3e5 - 09232026-0946) jorgemariogonza***';
